// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1QckU","col":"styles_col__LEmWT"};